module.exports = __webpack_public_path__ + "static/media/goblin_momma_club.60de5466.png";